import angular from 'angular';
import { ENVIRONMENT } from '@updater-core/lib/environment';

export const EnvironmentService = angular
  .module('app.environment', [])
  .constant('updEnvironment', ENVIRONMENT);
